const GridIcon = ({ color, className, onClick }: {color?: string, className?: string, onClick?: () => void}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    onClick={onClick}
  >
    <rect x="10" y="10" width="8" height="8" rx="1.5" fill="none" stroke={color || "#888"} strokeWidth="1.5" />
    <rect x="22" y="10" width="8" height="8" rx="1.5" fill="none" stroke={color || "#888"} strokeWidth="1.5" />
    <rect x="10" y="22" width="8" height="8" rx="1.5" fill="none" stroke={color || "#888"} strokeWidth="1.5" />
    <rect x="22" y="22" width="8" height="8" rx="1.5" fill="none" stroke={color || "#888"} strokeWidth="1.5" />
  </svg>
);

export default GridIcon;
